import { mountRaceList } from './utils/mount-race-list.js';
import { LA_CITY_URL } from './constants.js';
import { SHARED_RACES } from './shared-races.js';

// City of L.A. ballot measures (L.A. Vote), sorted by title. AP also covers
// some of them; scripts/shared-races.js picks which feed each one comes from.

// first parameter here needs to match what's in the multipleRaces js file
mountRaceList('la-city-ballot-measure-results', LA_CITY_URL, {
  // Keeps races whose jurisdiction is 'Los Angeles' and whose electionType is
  // 'measure'. Jurisdiction has to match the feed exactly. These races have no
  // tags, so filter by jurisdiction, not tagsAny. See FilterSpec in stores.js
  // for the other filters.
  filter: [
    {
      jurisdictions: ['Los Angeles'],
      electionType: ['measure'],
      sort: 'title',
    },
  ],
  component: 'result', // to show 2 col table
  // Shows AP's race in place of L.A. Vote's for the ones set to 'ap'
  sharedRaces: SHARED_RACES,
}).catch(console.error);
